export function keysToWords(givenWord){
    return String(givenWord).replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}